import { ArrowBackIosNewRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import styles from "./Offers.module.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as Dustbin } from "../assets/Dustbin.svg";
import axios from "axios";
import TextEditor from "../Components/TextEditor/TextEditor";
import DialogTextField from "../Components/Dialog/DialogTextField";
import isDesktop from "../isDesktop";
import OffersMobile from "./OffersMobile";
import { hasStoredTabAccess } from '../utils/access';

const typeArray = ["Monthly", "Yearly"];

const Offers = () => {
  const [isOpen, setIsOpen] = useState({
    add: false,
    update: false,
  });
  const [isReplicateDialogOpen, setIsReplicateDialogOpen] = useState(false);
  const [postData, setPostData] = useState({
    id: "",
    name: "",
    specId: "",
    features: [],
    basicFeatures: [],
    basicCostMonthly: "",
    basicCostYearly: "",
    standardFeatures: [],
    standardCostMonthly: "",
    standardCostYearly: "",
    premiumFeatures: [],
    premiumCostMonthly: "",
    premiumCostYearly: "",
    discount: "",
  });
  const [specialization, setSpecialization] = useState([]);
  const [offers, setOffers] = useState([]);
  const [isDeleteOpen,setIsDeleteOpen]=useState(false)
  const [offerToDelete,setOfferToDelete]=useState(null)
  const [offerToReplicate,setOfferToReplicate]=useState(null)
  const isAuthorized = hasStoredTabAccess('Offers');
  const navigate = useNavigate();

  const fetchSpecializations = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/specialization/all`
      );

      if (response.status === 200) {
        console.log(response.data.data);
        setSpecialization(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching specialization data", error);
    }
  };

  const fetchAllOffers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/get/all`
      );
      setOffers(response?.data?.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const AddOffer = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/post`,
        {
          ...postData,
        }
      );
      if (response.status === 200) {
        toast.success("Offer added successfully");
        fetchAllOffers();
        handleClose();
      }
    } catch (error) {
      console.error(error);

      toast.error("Error adding offer");
    }
  };

  const editOffer = async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/edit/${postData.id}`,
        {
          ...postData,
        }
      );
      if (response.status === 200) {
        toast.success("Offer updated successfully");
        fetchAllOffers();
        handleClose();
      }
    } catch (error) {
      console.error(error);

      toast.error("Error adding offer");
    }
  };


  const handleConfirmDelete=async()=>{
    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/delete/${offerToDelete}`
      );
      if (response.status===200) {
        toast.success("Offer deleted Successfully")
        setIsDeleteOpen(false)
        setOfferToDelete(null)
        fetchAllOffers()
      }
    } catch (error) {
      console.error(error);

      toast.error(error.response.data.message);
    }
  }

  const onEditOpen = async (id) => {
    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/get/${id}`
      );
      const data = response.data.data[0];
      const specName = specialization.find(
        (spec) => spec.specialization_id === data.spec_id
      );
      setPostData({
        id: id,
        name: data.offer_name,
        specId: data.spec_id,
        specName: specName,
        features: JSON.parse(data.features),
        basicFeatures: JSON.parse(data.basic_features),
        basicCostMonthly: data.basic_cost_monthly,
        basicCostYearly: data.basic_cost_yearly,
        standardFeatures: JSON.parse(data.standard_features),
        standardCostMonthly: data.standard_cost_monthly,
        standardCostYearly: data.standard_cost_yearly,
        premiumFeatures: JSON.parse(data.premium_features),
        premiumCostMonthly: data.premium_cost_monthly,
        premiumCostYearly: data.premium_cost_yearly,
        discount: data.discount,
      });
      await fetchSpecializations();
      setIsOpen({
        add: false,
        update: true,
      });
    } catch (error) {
      console.error(error);

      toast.error(error.response.data.message);
    }
  };

  const handleClose = () => {
    setIsOpen({ open: false, update: false });
    setPostData({
      id: "",
      name: "",
      specId: "",
      features: [],
      basicFeatures: [],
      basicCostMonthly: "",
      basicCostYearly: "",
      standardFeatures: [],
      standardCostMonthly: "",
      standardCostYearly: "",
      premiumFeatures: [],
      premiumCostMonthly: "",
      premiumCostYearly: "",
      discount: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setPostData((prev) => ({ ...postData, [name]: value }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    console.log(value);

    setPostData((prev) => ({
      ...postData,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  useEffect(() => {
    fetchAllOffers();
  }, [fetchAllOffers]);

  const handleBack = () => {
    navigate("/");
  };

  const onAddPress = () => {
    fetchSpecializations();
    setIsOpen((prev) => ({
      ...prev,
      add: true,
    }));
  };

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "2rem" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }

  const handleFeatureChange = (e, index) => {
    const { value } = e.target;
    const featureArray = [...postData.features];
    featureArray[index] = value;
    setPostData((prev) => ({
      ...prev,
      features: featureArray,
    }));
  };

  const addFeature = () => {
    setPostData((prev) => ({
      ...prev,
      features: [...prev.features, ""],
    }));
  };

  const deleteFeature = (index) => {
    const featuresArr = [...postData.features];
    const basicFeatures = [...postData.basicFeatures].filter(
      (val) => val !== index
    );
    const standardFeatures = [...postData.standardFeatures].filter(
      (val) => val !== index
    );
    const premiumFeatures = [...postData.premiumFeatures].filter(
      (val) => val !== index
    );
    featuresArr.splice(index, 1);
    setPostData((prev) => ({
      ...prev,
      features: featuresArr,
      basicFeatures: basicFeatures,
      standardFeatures: standardFeatures,
      premiumFeatures: premiumFeatures,
    }));
  };

  const handleReplicateSubmit=async()=>{
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/offers/replicate`,
        {
          id:offerToReplicate,
          newName:postData.name,
          newSpecId:postData.specId
        }
      );
      if (response.status === 200) {
        toast.success("Offer Replicated successfully");
        fetchAllOffers();
        handleReplicateDialogClose();
      }
    } catch (error) {
      console.error(error);

      toast.error(error.response.data.message);
    }
  }

  const handlReplicateDialogOpen=async(id)=>{
    await fetchSpecializations();
    setOfferToReplicate(id)
    setIsReplicateDialogOpen(true);
  }

  const handleReplicateDialogClose = () => {
    setIsReplicateDialogOpen(false);
    setOfferToReplicate(null)
    setPostData({
      id: "",
      name: "",
      specId: "",
      features: [],
      basicFeatures: [],
      basicCostMonthly: "",
      basicCostYearly: "",
      standardFeatures: [],
      standardCostMonthly: "",
      standardCostYearly: "",
      premiumFeatures: [],
      premiumCostMonthly: "",
      premiumCostYearly: "",
      discount: "",
    })

  };
  const isDesktopDevice=isDesktop()
  return (
    <>
    {
      isDesktopDevice?
      <>
      <div style={{ paddingTop: "5vw" }}>
        <Card
          elevation={3}
          className="col-md-12 p-3"
          style={{ boxShadow: "none" }}
        >
          <CardContent>
            <div className={styles.header}>
              <h2 className={styles.pageHeader}>
                <ArrowBackIosNewRounded
                  onClick={handleBack}
                  style={{ cursor: "pointer" }}
                />{" "}
                Offers
              </h2>
              <div className={styles.headerRight}>
                <Button
                  style={{
                    width: "15.385vw",
                    height: "2.564vw",
                    padding: "1.026vw 2.308vw 1.026vw 2.308vw",
                    gap: "0.641vw",
                    borderRadius: "4px",
                    color: "#ffffff",
                    fontSize: "0.897vw",
                    backgroundColor: "#37446F",
                    boxShadow:
                      " 3.13px 3.13px 6.25px 0px #59596F80, -2.08px -2.08px 6.25px 0px #FFFFFF ",
                  }}
                  onClick={() => {
                    onAddPress();
                  }}
                >
                  Add
                </Button>
              </div>
            </div>
            <ToastContainer />
            <table className={styles.mainTable}>
              <thead className={styles.tableHead}>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      paddingLeft: "2vw",
                      width: "20%",
                    }}
                  >
                    S. No.
                  </th>
                  <th style={{ width: "50%", textAlign: "left" }}>Name</th>
                  <th
                    style={{
                      textAlign: "left",
                      paddingLeft: "5.128vw",
                      width: "fit-content",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {offers.map((offer) => (
                  <tr key={offer?.id} className={styles.tableBody}>
                    <td
                      style={{
                        textAlign: "left",
                        paddingLeft: "3vw",
                        width: "20%",
                      }}
                    >
                      {offer?.id}
                    </td>
                    <td style={{ textAlign: "left" }}>{offer?.offer_name}</td>
                    <td style={{ paddingLeft: "5.128vw" }}>
                      <div className={styles.buttonContainer}>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={() => {
                            onEditOpen(offer.id);
                          }}
                          style={{
                            backgroundColor: "#D1F4DE",
                            height: "2.051vw",
                            width: "7.179vw",
                            color: "black",
                            textTransform: "capitalize",
                          }}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          fullWidth
                          onClick={() => {
                            handlReplicateDialogOpen(offer?.id)
                          }}
                          style={{
                            height: "2.051vw",
                            width: "7.179vw",
                            color: "black",
                            textTransform: "capitalize",
                            backgroundColor: "#FCF6BC",
                          }}
                          sx={{
                            fontSize: "0.897vw",
                          }}
                        >
                          Replicate
                        </Button>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={() => {setIsDeleteOpen(true);setOfferToDelete(offer.id)}}
                          style={{
                            backgroundColor: "#FFD6D2",
                            height: "2.051vw",
                            width: "7.179vw",
                            color: "black",
                            textTransform: "capitalize",
                          }}
                        >
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
      <Dialog
        open={isOpen.add || isOpen.update}
        PaperProps={{
          style: {
            width: "fit-content",
            maxWidth: "80vw",
            padding: "1.5rem",
            borderRadius: "0.513vw",
            overflowX: "hidden",
            boxShadow:
              "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
          },
        }}
        onClose={handleClose}
      >
        <DialogTitle style={{ fontWeight: "600", paddingBottom: "0" }}>
          {isOpen.update ? "Edit" : "Add"} Plan
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <DialogTextField
                name="name"
                label="New Plan Name"
                fullWidth
                required
                value={postData.name}
                onChange={handleInputChange}
                style={{
                  width: "32.051vw",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                id="specId"
                options={specialization}
                getOptionLabel={(option) => option?.specialization_name}
                value={postData.specName}
                onChange={(e, value) => {
                  setPostData((prev) => {
                    return {
                      ...prev,
                      specId: value?.specialization_id,
                      specName: value?.specialization_name,
                    };
                  });
                }}
                renderInput={(params) => (
                  <DialogTextField
                    {...params}
                    variant="outlined"
                    required
                    fullWidth
                    label="Specialization Name"
                    // placeholder="Specialization Name"
                    style={{
                      width: "32.051vw",
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">Basic Plan Features</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="basicFeatures"
                  style={{
                    width: "32.051vw",
                  }}
                  multiple
                  name="basicFeatures"
                  value={postData.basicFeatures}
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Basic Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.basicFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                label="Monthly Price"
                required
                name="basicCostMonthly"
                value={postData.basicCostMonthly}
                onChange={handleInputChange}
                style={{
                  width: "15.641vw",
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                label="Yearly Price"
                required
                name="basicCostYearly"
                value={postData.basicCostYearly}
                onChange={handleInputChange}
                style={{
                  width: "15.641vw",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">
                  Standard Plan Features
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  style={{
                    width: "32.051vw",
                  }}
                  multiple
                  value={postData.standardFeatures}
                  name="standardFeatures"
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Standard Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.standardFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                name="standardCostMonthly"
                label="Monthly Price"
                value={postData.standardCostMonthly}
                onChange={handleInputChange}
                style={{
                  width: "15.641vw",
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                label="Yearly Price"
                name="standardCostYearly"
                value={postData.standardCostYearly}
                onChange={handleInputChange}
                style={{
                  width: "15.641vw",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="basicFeatures">
                  Premium Plan Features
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  style={{
                    width: "32.051vw",
                  }}
                  multiple
                  name="premiumFeatures"
                  value={postData.premiumFeatures}
                  onChange={handleSelectChange}
                  input={<OutlinedInput label="Premium Plan Features" />}
                  renderValue={(selected) => selected.join(", ")}
                  // MenuProps={MenuProps}
                >
                  {postData.features.map((name, index) => (
                    <MenuItem key={name} value={index}>
                      <Checkbox
                        checked={postData.premiumFeatures.includes(index)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                label="Monthly Price"
                style={{
                  width: "15.641vw",
                }}
                name="premiumCostMonthly"
                value={postData.premiumCostMonthly}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={3}>
              <DialogTextField
                label="Yearly Price"
                name="premiumCostYearly"
                value={postData.premiumCostYearly}
                onChange={handleInputChange}
                style={{
                  width: "15.641vw",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <DialogTextField
                style={{
                  width: "32.051vw",
                }}
                name="discount"
                value={postData.discount}
                onChange={handleInputChange}
                label="Discount"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} marginTop={3}>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontWeight: "600",
                  paddingBottom: "0",
                  fontSize: "1.25rem",
                  lineHeight: 1.6,
                }}
              >
                Features
              </Typography>
            </Grid>
            <Grid
              item
              container
              xs={6}
              direction={"row"}
              justifyContent={"end"}
            >
              <Button
                style={{
                  width: "15.385vw",
                  height: "2.564vw",
                  padding: "1.026vw 2.308vw 1.026vw 2.308vw",
                  gap: "0.641vw",
                  borderRadius: "4px",
                  color: "#ffffff",
                  fontSize: "0.897vw",
                  backgroundColor: "#37446F",
                  gridColumn: "1/2",
                  boxShadow:
                    " 3.13px 3.13px 6.25px 0px #59596F80, -2.08px -2.08px 6.25px 0px #FFFFFF ",
                }}
                onClick={addFeature}
              >
                Add Features
              </Button>
            </Grid>
            {postData.features.map((feature, index) => (
              <Grid
                key={index}
                item
                container
                xs={6}
                sx={{
                  gap: "1.026vw",
                }}
              >
                <DialogTextField
                  label="Feature"
                  value={feature}
                  onChange={(e) => {
                    handleFeatureChange(e, index);
                  }}
                  style={{
                    width: "27.949vw",
                  }}
                />
                <IconButton
                  style={{
                    borderRadius: "0px",
                    height: "3.577vw",
                    width: "3.577vw",
                    padding: "13px",
                    boxShadow:
                      "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                  }}
                  onClick={() => {
                    deleteFeature(index);
                  }}
                >
                  <Dustbin />
                </IconButton>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            className="outlined-button"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              isOpen.add ? AddOffer() : editOffer();
            }}
            variant="contained"
            className="filled-button"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isReplicateDialogOpen}
        onClose={handleReplicateDialogClose}
        PaperProps={{
          style: {
            width: "35.128vw",
            borderRadius: "0.513vw",
            boxShadow:
              "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
          },
        }}
      >
        <DialogTitle>Replicate Subscription Plan</DialogTitle>
        <DialogContent>
          <DialogTextField
            name="name"
            label="New Plan Name"
            fullWidth
            required
            value={postData.name}
            onChange={handleInputChange}
            style={{
              width: "32.051vw",
              marginBottom:"1vw",
              marginTop:"0.5vw"
            }}
          />
          <Autocomplete
            id="specId"
            options={specialization}
            getOptionLabel={(option) => option?.specialization_name}
            value={postData.specName}
            onChange={(e, value) => {
              setPostData((prev) => {
                return {
                  ...prev,
                  specId: value?.specialization_id,
                  specName: value?.specialization_name,
                };
              });
            }}
            renderInput={(params) => (
              <DialogTextField
                {...params}
                variant="outlined"
                required
                fullWidth
                label="Specialization Name"
                // placeholder="Specialization Name"
                style={{
                  width: "32.051vw",
                  marginBottom:"1vw"
                }}
              />
            )}
          />

          <DialogActions>
            <Button
              onClick={handleReplicateDialogClose}
              className="outlined-button"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleReplicateSubmit}
              className="filled-button"
              variant="contained"
            >
              Replicate
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
          open={isDeleteOpen}
          onClose={(prev) => !prev}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ textAlign: "center" }}
        >
          <ErrorOutlineIcon
            style={{ color: "red", fontSize: "32px", margin: "12px auto" }}
          />
          <DialogTitle
            id="alert-dialog-title"
            style={{ fontSize: "18px", fontWeight: "500", lineHeight: "0" }}
          >
            {"Are you Sure?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ fontSize: "12px" }}
            >
              You won't be able to revert this!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {setIsDeleteOpen(false);
                setOfferToDelete(null)}
              }
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                border: "2.03px solid #37446F",
                borderRadius: "5.85px",
                background: "none",
                color: "black",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              style={{
                textTransform: "none",
                width: "120px",
                height: "36px",
                borderRadius: "5.85px",
                background: "#37446F",
                color: "white",
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        </>
      :<OffersMobile />
    }
      
    </>
  );
};

export default Offers;
